import Button from "@atlaskit/button";
import RefreshIcon from "@atlaskit/icon/glyph/refresh";

import {
    rotateRestartButtonStyle,
    fadeInRestartButtonStyle
} from "./jsw-interactive-board.styles";
import { useInteractiveBoardStore } from "./state";

export const RestartButton = () => {
    const [{ messages, isDemoComplete }, { restartDemo }] =
        useInteractiveBoardStore();
    const { restartDemo: restartDemoString = "" } = messages;

    const clickHandler = () => {
        void restartDemo();
    };

    return (
        <Button
            appearance="subtle-link"
            onClick={clickHandler}
            iconAfter={<RefreshIcon label="" />}
            isDisabled={!isDemoComplete}
            css={[rotateRestartButtonStyle, fadeInRestartButtonStyle]}
        >
            {restartDemoString}
        </Button>
    );
};
